import React, { useEffect, useState } from 'react';
import Select from 'react-select/creatable';
import { toast } from '../../utils/helpers';
import { catalogoUnidadesCompleto, crearUnidadConfig } from '../../utils/unidades';

const CrearProductoModal = ({toggle, grupos, productoNuevo, crearProductoNuevo}) => {
    const [state, setState] = useState({
        nombre: productoNuevo.nombre,
        referencia: productoNuevo.referencia,
        unidad: productoNuevo.unidad,
        empaque: productoNuevo.empaque ?? null,
        cantidadEmpaque: productoNuevo.cantidadEmpaque ?? '',
        categoria: productoNuevo.categoria,
    });
    const [unidades, setUnidades] = useState([]);
    const [creando, setCreando] = useState(false);

    useEffect(() => {
        catalogoUnidadesCompleto().then((catalogo) => {
            setUnidades(catalogo);
            // Sin unidad elegida arranca en UND, ya enlazada con el catálogo.
            setState((prev) => prev.unidad
                ? prev
                : { ...prev, unidad: catalogo.find((u) => u.value === 'UND') ?? null });
        });
    }, []);

    const onChangeInput = (name, value) => {
        setState((prev) => ({
            ...prev,
            [name]: value
        }));
    }

    // Crea la unidad en el catálogo real para que tenga id (unidad_id).
    const crearUnidad = async (campo, valor) => {
        setCreando(true);
        const nueva = await crearUnidadConfig(valor);
        setCreando(false);

        if (nueva) {
            setUnidades((prev) => [...prev, nueva]);
            onChangeInput(campo, nueva);
        }
    }

    const onClickGuardar = () => {
        if (!state.categoria) {
            toast('Debes seleccionar una categoria', 'error');
            return;
        }

        if (state.empaque) {
            if (state.empaque.value === state.unidad?.value) {
                toast('El empaque debe ser una unidad distinta a la unidad base', 'error');
                return;
            }
            if (!(parseFloat(state.cantidadEmpaque) > 1)) {
                toast('La cantidad en paquete debe ser mayor que 1', 'error');
                return;
            }
        }

        crearProductoNuevo(state.empaque ? state : { ...state, cantidadEmpaque: '' });
        toggle();
    }

    return (
        <>
            <div className='popup__header'>Nuevo Producto</div>
            <div className="popup__body">
                <div className="row">
                    <div className="col-md-6">
                        <label>Nombre:</label>
                        <div>{state.nombre}</div>
                    </div>
                    <div className="col-md-6">
                        <label>Referencia/Código</label>
                        <input
                            type="text"
                            value={state.referencia}
                            onChange={(e) => onChangeInput('referencia', e.target.value)}
                            className="form-control"
                        />
                    </div>
                    <div className="col-md-6">
                        <label>Unidad base</label>
                        <Select
                            menuPosition='fixed'
                            menuPlacement='auto'
                            value={state.unidad}
                            isLoading={creando}
                            isDisabled={creando}
                            onChange={(e) => onChangeInput('unidad', e)}
                            onCreateOption={(valor) => crearUnidad('unidad', valor)}
                            options={unidades}
                        />
                    </div>
                    <div className="col-md-6">
                        <label>Categoría</label>
                        <Select
                            menuPosition='fixed'
                            menuPlacement='auto'
                            value={state.categoria}
                            onChange={(e) => onChangeInput('categoria', {
                                label: e.label,
                                value: e.value,
                            })}
                            options={grupos?.map(g => ({
                                label: g.nombre,
                                value: g.nombre
                            }))}
                        />
                    </div>
                    <div className="col-md-6 m-t-10">
                        <label>Empaque</label>
                        <Select
                            menuPosition='fixed'
                            menuPlacement='auto'
                            isClearable
                            placeholder="Sin empaque"
                            value={state.empaque}
                            isLoading={creando}
                            isDisabled={creando}
                            onChange={(e) => onChangeInput('empaque', e)}
                            onCreateOption={(valor) => crearUnidad('empaque', valor)}
                            options={unidades.filter((u) => u.value !== state.unidad?.value)}
                        />
                    </div>
                    <div className="col-md-6 m-t-10">
                        <label>Cantidad en paquete</label>
                        <input
                            type="number"
                            min="2"
                            step="any"
                            value={state.empaque ? state.cantidadEmpaque : ''}
                            disabled={!state.empaque}
                            onChange={(e) => onChangeInput('cantidadEmpaque', e.target.value)}
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
            <div className='popup__footer'>
                <button
                    type='button'
                    onClick={toggle}
                    className='btn btn-plain'>
                    Cancelar
                </button>
                <button type='button' onClick={onClickGuardar} className='btn btn-primary'>
                    Guardar
                </button>
            </div>
        </>
    )
}

export default CrearProductoModal;
